/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Findus_Proptech_RoleInputs */

const en_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front-end Lead`)
};

const ar_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائد الواجهة الأمامية`)
};

const bn_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফ্রন্ট-এন্ড লিড`)
};

const de_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front-End-Lead`)
};

const es_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Líder de front-end`)
};

const fr_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsable front-end`)
};

const pt_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead de front-end`)
};

const zh_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前端负责人`)
};

const tr_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ön Uç Lideri`)
};

const ru_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководитель фронт-энда`)
};

const pl_experience_findus_proptech_role = /** @type {(inputs: Experience_Findus_Proptech_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Główny lider front-endu`)
};

/**
* | output |
* | --- |
* | "Front-end Lead" |
*
* @param {Experience_Findus_Proptech_RoleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_findus_proptech_role = /** @type {((inputs?: Experience_Findus_Proptech_RoleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Findus_Proptech_RoleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_findus_proptech_role(inputs)
	if (locale === "bn") return bn_experience_findus_proptech_role(inputs)
	if (locale === "de") return de_experience_findus_proptech_role(inputs)
	if (locale === "es") return es_experience_findus_proptech_role(inputs)
	if (locale === "fr") return fr_experience_findus_proptech_role(inputs)
	if (locale === "pt") return pt_experience_findus_proptech_role(inputs)
	if (locale === "zh") return zh_experience_findus_proptech_role(inputs)
	if (locale === "tr") return tr_experience_findus_proptech_role(inputs)
	if (locale === "ru") return ru_experience_findus_proptech_role(inputs)
	if (locale === "pl") return pl_experience_findus_proptech_role(inputs)
	return en_experience_findus_proptech_role(inputs)
});